/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Hours_ShortInputs */

const en_admin_resource_form_hours_short = /** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

const de_admin_resource_form_hours_short = /** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

const es_admin_resource_form_hours_short = /** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

const fr_admin_resource_form_hours_short = /** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`h`)
};

const nl_admin_resource_form_hours_short = /** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`u`)
};

/** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */
const it_admin_resource_form_hours_short = en_admin_resource_form_hours_short;

/** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */
const pt_br2_admin_resource_form_hours_short = en_admin_resource_form_hours_short;

/** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */
const pl_admin_resource_form_hours_short = en_admin_resource_form_hours_short;

/** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */
const hu_admin_resource_form_hours_short = en_admin_resource_form_hours_short;

/** @type {(inputs: Admin_Resource_Form_Hours_ShortInputs) => LocalizedString} */
const ro_admin_resource_form_hours_short = en_admin_resource_form_hours_short;

/**
* | output |
* | --- |
* | "h" |
*
* @param {Admin_Resource_Form_Hours_ShortInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_hours_short = /** @type {((inputs?: Admin_Resource_Form_Hours_ShortInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Hours_ShortInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_hours_short(inputs)
	if (locale === "de") return de_admin_resource_form_hours_short(inputs)
	if (locale === "es") return es_admin_resource_form_hours_short(inputs)
	if (locale === "fr") return fr_admin_resource_form_hours_short(inputs)
	if (locale === "nl") return nl_admin_resource_form_hours_short(inputs)
	if (locale === "it") return it_admin_resource_form_hours_short(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_hours_short(inputs)
	if (locale === "pl") return pl_admin_resource_form_hours_short(inputs)
	if (locale === "hu") return hu_admin_resource_form_hours_short(inputs)
	return ro_admin_resource_form_hours_short(inputs)
});
export { admin_resource_form_hours_short as "admin.resource_form.hours_short" }